import React, { useState, useEffect, useRef, forwardRef } from "react";
import { useHistory } from "react-router-dom";
import {Grid,
        Box,
        Typography,
        CircularProgress,
        Paper,
        MenuItem
} from "@material-ui/core";
import { ViewState, EditingState, IntegratedEditing/*, GroupingState, IntegratedGrouping, IntegratedEditing*/ } from '@devexpress/dx-react-scheduler';
import {
  Scheduler,
  WeekView,
  Appointments,
  AppointmentTooltip,
  AppointmentForm,
  Toolbar,
  ViewSwitcher,
  MonthView,
  DayView,
  TodayButton,
  DateNavigator,
  AllDayPanel,
  /*Resources,
  GroupingPanel,
  DragDropProvider*/
} from '@devexpress/dx-react-scheduler-material-ui';
import PropTypes from 'prop-types';
import { Button } from '../../components/Wrappers'
import ChatIcon from '@material-ui/icons/Chat';
import HistoryIcon from '@material-ui/icons/History';
import useStyles from './styles';
import ttAPI from '../../api/ttAPI';
import config from '../../config';
import Widget from '../../components/Widget';
import { sendNotification } from "../../context/UserContext";
import UpdateAccount from '../../components/Account/UpdateAccount';

const EditAccount = forwardRef((props, ref) => {

    const classes = useStyles();
    const history = useHistory();
    const updateAccountRef = useRef(null);
    const [locationState, setLocationState] = useState(props.location.state);
    const [paramsId, setParamsId] = useState(props.match.params.id);
    const [account, setAccount] = useState(undefined);

    const [isSaving, setIsSaving] = useState(false);
    const [isCreateAccountValid, setIsCreateAccountValid] = useState(false);
    const accountWidgetRef = useRef(null);

    // scheduler related
    var [data, setData] = useState([]);
    var [technicianSettingsSetups, setTechnicianSettingsSetups] = useState([]);
    var [currentViewName, setCurrentViewName] = useState('week');
    const colours = ['#EF5350','#EC407A','#AB47BC','#7E57C2','#5C6BC0','#42A5F5',
                     '#29B6F6','#26C6DA','#26A69A','#66BB6A','#9CCC65','#D4E157',
                     '#FFEE58','#FFCA28','#FFCA28','#FFA726','#FF7043','#8D6E63',
                     '#BDBDBD','#78909C','#E57373','#F06292','#BA68C8','#9575CD',
                     '#7986CB','#64B5F6','#4FC3F7','#4DD0E1','#4DB6AC','#81C784',
                     '#AED581','#DCE775','#FFF176','#FFD54F','#FFB74D','#FF8A65',
                     '#A1887F','#E0E0E0','#90A4AE'];
     var [resources, setResources] = useState(undefined);
     //const groupOrientation = viewName => viewName.split(' ')[0];
     var [grouping, setGrouping] = useState([{
           resourceName: 'jobId',
         },/*{
           resourceName: 'worker',
         }*/]);
     var [showScheduler, setShowScheduler] = useState(false);
     var [isLoading, setIsLoading] = useState(false);
     //const nzTime = date => (new Date(date)).toLocaleString('en-NZ', { timeZone: 'Pacific/Auckland' });



    /*const [siteTabValue, setSiteTabValue] = useState(0);
    const [customerTabValue, setCustomerTabValue] = useState(0);*/

    function TabPanel(props) {
      const { children, value, index, ...other } = props;

      return (
        <div
          role="tabpanel"
          hidden={value !== index}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
          {...other}
        >
          {value === index && (
            <Box p={3}>
              <Typography component="div">{children}</Typography>
            </Box>
          )}
        </div>
      );
    }

    TabPanel.propTypes = {
      children: PropTypes.node,
      index: PropTypes.any.isRequired,
      value: PropTypes.any.isRequired,
    };

    /*function a11yProps(index) {
      return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
      };
    }*/

    useEffect(() => {
        let mounted = true;
        const accountId = locationState === undefined ? paramsId : locationState.accountId;

        async function fetchTechnicianSettingsSetups() {
            const response = await ttAPI.getTechnicianSettingsSetups();
            if (response !== undefined && response !== null) {
              if(mounted){
                  setTechnicianSettingsSetups(response);
              }
            }
        }
        async function fetchData() {

            const response = await ttAPI.loadAccount(accountId);
            if (response !== undefined && response !== null) {
              if(mounted){
                  setAccount(response);
              }
            }
        }

        const fetchScheduleData = async() => {
          setIsLoading(true);
          const response = await ttAPI.getWorkerSchedules(accountId);
          if(mounted){
            if (response !== null && response !== undefined &&
                response.jobs !== null && response.jobs !== undefined) {
              /*var filteredJobs = response.jobs.filter(function(r)
               {
                   return r.id !== 62560;
               });*/

               setData(response.jobs.map(function (workerJobSchedule) {
                  return {
                    id: `${workerJobSchedule.id}_${response.id}`,
                    startDate: new Date(workerJobSchedule.start),
                    endDate: new Date(workerJobSchedule.finish),
                    title: `${workerJobSchedule.id} - ${workerJobSchedule.customer_name} - ${workerJobSchedule.site_name}`,
                    worker: response.name,
                    jobId: workerJobSchedule.id,
                    regionId: workerJobSchedule.job_region_id
                  };
                }));
             }
             setIsLoading(false);
          }

           //setData([{id: 1, title: 'test', startDate: "2021-01-20T10:27:10.000", endDate: "2021-01-21T18:11:04.785",}]);

        };

        fetchTechnicianSettingsSetups();

        if (accountId !== undefined && accountId > 0) {
            fetchData();
            fetchScheduleData();
        }
        else {
          setAccount({level: 1, active: true, proof_access: false, technician_settings:{}});
        }

        return () => mounted = false;
    },[locationState, paramsId]);


    useEffect(() => {
       if (data != null && data !== undefined && data.length > 0) {
         let names = data.map(({ worker }) => worker);
         let uniqueNames = [...new Set(names)];

         var resourcesInstances = [];
         var colourIndex = 0;
         uniqueNames.map(function (un, index) {
            if (colourIndex >= colours.length) {
              colourIndex = 0;
            }
            resourcesInstances[index] = {id: index, text: un, color: colours[colourIndex++]}
          });

          let jobs = data.map(({ id }) => id);
          let uniqueJobs = [...new Set(jobs)];
          var resourcesJobInstances = [];
          colourIndex = 0;
          uniqueJobs.map(function (uj, index) {
             if (colourIndex >= colours.length) {
               colourIndex = 0;
             }
             resourcesJobInstances.push({id: index, text: uj, color: colours[colourIndex++]});
           });



          setResources([{
             fieldName: 'jobId',
             title: 'Job',
             instances: resourcesJobInstances,
             allowMultiple: true,
           },/*{
            fieldName: 'worker',
            title: 'Technician',
            instances:resourcesInstances,
          allowMultiple: true,}*/]);
       }

     }, [data]);

     useEffect(() => {
       if (resources !== undefined && resources !== null) {
         setShowScheduler(true);
       }
       else {
         setShowScheduler(false);
       }
       }, [resources]);


    const disableSaveButton = () => {
      return isSaving || !isCreateAccountValid;
    }

  /*  function handleSiteTabChange(event, newValue) {
      setSiteTabValue(newValue);
    }

    function handleCustomerTabChange(event, newValue) {
      setCustomerTabValue(newValue);
    }
*/



    const handleSave = async () => {
        setIsSaving(true);
        var accountToSave = account;
        // NOTE: here the account.technician_settings is already stringified
        if (account.technician_settings === '{}') {
              accountToSave.technician_settings = null;
        }

        // if customer id is selected i.e. for customer account creation
        if (account.customer_id !== null && account.customer_id !== undefined && account.customer_id > 0) {
              // make sure whatever franchise selected is cleared
              account.franchise_id = null;
        }
        console.log(accountToSave)
        const response = await ttAPI.saveAccount(accountToSave);
        if (response.id > 0) {
          sendNotification('success', `Success - Account ${response.id} ${account.id > 0 ? 'Updated' : 'Created'}.`, classes);
          if (account.id === undefined || account.id === null || account.id <= 0) {
              updateAccountRef.current.uploadAccountPhoto(response.id);
          }
          else {
              setIsSaving(false);
              history.push({pathname:`/app/account/edit/${response.id}`,
                                       state:{accountId: response.id}
                                     });
          }
        }
        else {
          setIsSaving(false);
          sendNotification('error', `Error - ${account.id > 0 ? 'Updaing' : 'Creating'} account. ${response.error}`, classes );
        }
    }

    function onAccountFormUpdated(isValid) {
        setIsCreateAccountValid(isValid);
    }

    function onAccountUpdated(updatedAccount) {
        setAccount({
          ...account,
          name: updatedAccount.name,
          signon: updatedAccount.signon,
          email: updatedAccount.email,
          phone: updatedAccount.phone,
          password: updatedAccount.password,
          level: updatedAccount.level,
          customer_id: updatedAccount.customer_id,
          franchise_id: updatedAccount.franchise_id,
          customer_access: updatedAccount.customer_access,
          franchise_access: updatedAccount.franchise_access,
          account_access: updatedAccount.account_access,
          proof_access: updatedAccount.proof_access,
          technician_settings: updatedAccount.technician_settings === null || updatedAccount.technician_settings === undefined || Object.keys(updatedAccount.technician_settings).length === 0 ? null : JSON.stringify(updatedAccount.technician_settings),
          home_address: updatedAccount.home_address,
          home_mapurl: updatedAccount.home_mapurl,
          home_geo_locality: updatedAccount.home_geo_locality,
          home_geo_region_id: updatedAccount.home_geo_region_id,
          active: updatedAccount.active
        });
    }

    function onPhotoUploaded() {
        setIsSaving(false);
    }

    function currentViewNameChange(cvn) {
        setCurrentViewName(cvn);
    }

    function openTeamChat() {
      if (account.id === undefined) {
          sendNotification('error','Cannot open a team chat while creating a new user.');
      }
      else {
          window.open(
          `${config.teamChatUrl.replace('<USERS>', account.email).replace('<TOPIC_NAME>','Individual%20Chat')}`,
          '_blank'
          );
      }

      accountWidgetRef.current.closeWidgetMoreMenu();
    }

    const downloadHistory = () => {
      if (account.id === undefined) {
          sendNotification('error','Cannot download history while creating a new user.');
      }
      else {
          window.open(`${config.clientApi}/reports/audit/account?id=${account.id}`,'_blank');
      }


      accountWidgetRef.current.closeWidgetMoreMenu();
    }

    /*const openJobButton = React.useCallback(
       (props, appointmentData) => {
         const { id } = props;

console.log(props);console.log(EditingState.editingAppointment);
         return <AppointmentForm.CommandButton {...props} onExecute={() => window.open("https://google.com","_blank")}
         getMessage={(message) => {console.loge(message); return message;}} />;
       },
       []
     );*/


  return (
    <div className={classes.contentDiv}>

      {account &&
        <Grid container spacing={4}>
            <Grid item xs={12} md={6} sm={6}>
            <Box display={'flex'}
                justifyContent={'flex-end'}
                style={{marginBottom: '-20px', marginRight: '60px', marginTop: '20px'}}
            >
                <Button style={{position: 'fixed', zIndex: '10'}}
                    className={classes.saveEditAccountButton}
                    variant="contained"
                    color="primary"
                    disabled={disableSaveButton()}
                    onClick={handleSave}
                >
                {isSaving && <span className={classes.savebuttonText}><CircularProgress size={25}/> Saving Account...</span>}
                {!isSaving && <span className={classes.savebuttonText}>Save Account</span>}
                </Button>
            </Box>
                <Widget
                  title={`${account.id === undefined ? 'ADD Account' : `EDIT - Account (${account.id })`}`}
                  upperTitle
                  className={classes.card}
                  bodyClass={classes.fullHeightBody}
                  ref={accountWidgetRef}
                  menuItems={<div> <MenuItem onClick={downloadHistory}>
                                           <HistoryIcon/><Typography>Download History</Typography>
                                        </MenuItem>
                                        <MenuItem onClick={openTeamChat}>
                                                      <ChatIcon/><Typography>Team Chat</Typography>
                                                   </MenuItem>
                             </div>
                           }>



                    <UpdateAccount ref={updateAccountRef}
                                   account={account}
                                   technicianSettingsSetups={technicianSettingsSetups}
                                   onFormUpdated={onAccountFormUpdated}
                                   onAccountUpdated={onAccountUpdated}
                                   onPhotoUploaded={onPhotoUploaded}/>

                     <div className={classes.bottomMenu}>
                         <div>
                         <Box
                             display={'flex'}
                             justifyContent={'flex-end'}
                         >
                             <Button className={classes.saveEditAccountButton}
                                 variant="contained"
                                 color="primary"
                                 disabled={disableSaveButton()}
                                 onClick={handleSave}
                             >
                             {isSaving && <span className={classes.savebuttonText}><CircularProgress size={25}/> Saving Account...</span>}
                             {!isSaving && <span className={classes.savebuttonText}>Save Account</span>}
                             </Button>
                         </Box>
                         </div>
                     </div>
                </Widget>
            </Grid>

            {((account.account_access === undefined || account.account_access === null || !account.account_access) &&
                (account.franchise_access === undefined || account.franchise_access === null || !account.franchise_access) &&
                (account.customer_access === undefined || account.customer_access === null || !account.customer_access) &&
                (account.customer_id === undefined || account.customer_id === null )) &&

                <>{isLoading && <span><CircularProgress size={25}/> Loading...</span>}


            {!isLoading && <Grid item xs={12} md={6} sm={6} className={classes.overflowx}>
              <Grid container spacing={4}>

                <Grid item xs={12} md={12} sm={12}>
                <Widget
                 title="Schedules"
                 upperTitle
                 className={classes.formDisplay}
                 disableWidgetMenu>
                 {data !== undefined && data !== null
                   && resources !== undefined && resources !== null &&
                   <Paper>
                 <Scheduler
                   data={data}
                   locale="en-NZ"
                 >
                   <ViewState
                     defaultCurrentDate={ViewState.currentDate}
                     currentViewName={currentViewName}
                     onCurrentViewNameChange={currentViewNameChange}
                   />
                   <EditingState
                    onEditingAppointmentChange={(editingAppointment) => {
                         if (editingAppointment !== undefined && editingAppointment !== null &&
                             editingAppointment.jobId !== undefined && editingAppointment.jobId !== null) {
                               window.open(`${config.adminApi}/#/app/job/edit/${editingAppointment.jobId}`,'_blank');
                           }
                       }
                    }/>

                   <DayView cellDuration={60}/>
                   <WeekView cellDuration={60} name="week"/>
                   <MonthView />

                   <Toolbar />
                   <DateNavigator />
                   <TodayButton />
                   <ViewSwitcher />
                   <Appointments />

                   <AppointmentTooltip
                     showCloseButton
                     showOpenButton
                   />
                   <AppointmentForm
                     readOnly
                   />

                   <AllDayPanel/>

                 </Scheduler>
               </Paper>}
                 </Widget>
                </Grid>
              </Grid>
            </Grid>}</>}
        </Grid>}
    </div>
  );
});
export default EditAccount;
